import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import { PrimaryCard } from "../PrimaryCards/PrimaryCard";
import styles from "./BentoBoxSectionV2.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BentoBoxSectionV2 = function BentoBoxSectionV2(_ref) {
  var primaryCardOne = _ref.primaryCardOne,
    primaryCardTwo = _ref.primaryCardTwo;
  return /*#__PURE__*/_jsx("div", {
    className: styles.bentoBoxSectionContainer,
    children: /*#__PURE__*/_jsx("div", {
      className: styles.mainBentoBoxItems,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.primaryCards,
        children: [primaryCardOne && /*#__PURE__*/_jsx(PrimaryCard, _objectSpread(_objectSpread({}, primaryCardOne), {}, {
          options: _objectSpread(_objectSpread({}, primaryCardOne.options), {}, {
            largeDesktop: true
          }),
          version: "v2"
        })), primaryCardTwo && /*#__PURE__*/_jsx(PrimaryCard, _objectSpread(_objectSpread({}, primaryCardTwo), {}, {
          options: _objectSpread(_objectSpread({}, primaryCardTwo.options), {}, {
            largeDesktop: true
          }),
          version: "v2"
        }))]
      })
    })
  });
};